import $ from 'jquery'

const texts = document.querySelectorAll('.text-animation')
const heros = document.querySelectorAll('.hero')
const observer_options = {
    text: {},
    header: {},
    sp_footer: {}
}
const observer_text = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('is-show')
        }
    })
}, observer_options.text)

const observer_header = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            document.querySelector('.fixed-header').classList.remove('is-show')
        } else {
            document.querySelector('.fixed-header').classList.add('is-show')
        }
    })
}, observer_options.header)

const observer_sp_footer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            document.querySelector('.fadein-bottom').classList.remove('is-show')
        } else {
            document.querySelector('.fadein-bottom').classList.add('is-show')
        }
    })

} , observer_options.sp_footer)

texts.forEach(text => {
    observer_text.observe(text)
})
heros.forEach(hero => {
    observer_header.observe(hero)
})
heros.forEach(hero => {
    observer_sp_footer.observe(hero)
})
// 読み込み時に追従ヘッダーが見えてしまうので時間差でclass付与
setTimeout(() => {
    document.querySelector('.fixed-header').classList.add('is-ready')
}, .3)

const title = document.querySelectorAll('.jsAccordionTitle')
//forEachでtitleを一つ一つtitleEachに入れている
title.forEach(titleEach => {
//nextElementSiblingはjQueryのnext()みたいなもの
    let content = titleEach.nextElementSibling
    titleEach.addEventListener('click', () => {
        titleEach.classList.toggle('is-active')
        content.classList.toggle('is-open')
    })
})

$('.js-btn-form').on('click', () => {
    const offset = $('.form-attention').offset().top
    $('html, body').animate({ scrollTop: offset }, 1000)
})


const questionTitle = document.querySelectorAll('.question-item__heading')

questionTitle.forEach(titleEach => {
    const questionContent = titleEach.nextElementSibling
    titleEach.addEventListener('click', () => {
        titleEach.classList.toggle('is-active')
        questionContent.classList.toggle('is-open')
    })
})

